<template>
  <Modal
    :open="props.open"
    @close-modal="$emit('close-modal')"
    customHeight="h-180"
    customWidth="lg:w-220"
  >
    <template #modal-header>
      <div class="">
        <div class="flex items-center">
          <Icon name="Eye" class="w-4 h-4 mr-1 stroke-info" />
          <div class="text-sm font-inter font-semibold text-info">
            Preview {{ props.modal_config.record.file_name }}
          </div>
        </div>
        <div class="font-league tracking-[-.56px] font-semibold text-[1.75rem] text-strongest">
          Preview Document
        </div>
      </div>
    </template>

    <template #modal-body>
      <div>
        <div
          v-if="
            props.modal_config.record.file_type ===
            'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
          "
        >
          <div
            class="m-4 rounded border border-platform-outlines bg-white p-4"
            v-html="docContent"
          ></div>
        </div>

        <object
          v-else
          :data="props.modal_config.file_url"
          :type="props.modal_config.record.file_type"
          width="100%"
          height="825"
        ></object>
      </div>
    </template>
    <template #modal-footer>
      <div class="flex justify-end gap-2">
        <Button @click="$emit('close-modal')" variant="paper-primary" size="sm" class="">
          <template #label>Cancel</template>
        </Button>
      </div>
    </template>
  </Modal>
</template>

<script setup>
// IMPORTS
import { ref, watch } from "vue";
import { Modal, Icon, Button } from "@/components";
import { useCrudStore, useUIStore } from "@/stores";
import mammoth from "mammoth";
import useFileUtility from "@/composables/useFileUtility";

//STORES
const crudStore = useCrudStore();
const UIStore = useUIStore();

//EMITS AND PROPS
const emit = defineEmits(["close-modal", "refresh"]);
const props = defineProps({
  open: { type: Boolean, required: true },
  modal_config: { type: Object, required: true },
});

const { downloadFile_R2 } = useFileUtility();

const docContent = ref("");

async function handleDownload() {
  await downloadFile_R2(props.modal_config.record);
}

watch(
  () => props.modal_config.record,
  async (newVal) => {
    if (!newVal) {
      return;
    }

    let file_url = props.modal_config.file_url;

    if (!file_url || typeof file_url !== "string") {
      return;
    }

    try {
      const response = await fetch(file_url);

      if (!response.ok) {
        return;
      }

      const arrayBuffer = await response.arrayBuffer();

      if (
        newVal.file_type !==
        "application/vnd.openxmlformats-officedocument.wordprocessingml.document"
      ) {
        return;
      }

      const result = await mammoth.convertToHtml({ arrayBuffer });

      docContent.value = result.value;
    } catch (error) {
      console.error("[DocumentPreviewModal] Error processing file:", error);
    }
  },
  { immediate: true }
);
</script>
